import React, { Fragment } from 'react'
import { Link, RichText, Date } from 'prismic-reactjs'
import styled from 'styled-components'
import * as vars from '../style/vars'
import { above, below } from '../style/functions'
import Header from '../components/header.js'
import BrochureModal from '../components/brochureModal'
import Input from "../components/input"
import Photo from '../components/photo'
import NewsCard from '../components/news_card'
import TextBlock from '../components/content_block'
import TextBlockLogos from '../components/content_block_logos'
import Jumbotron from '../components/jumbotron'
import { Accordion, AccordionContainer } from '../components/accordion'
import LocationMap from '../components/location_map'
import { colors } from '../style/vars'
import Masterplan from "../components/masterplan"
import StickyEnquire from "../components/sticky-enquire";
import Video from '../components/video'

class errorPage extends React.Component {
   state = {
      location: null,
   }



   componentWillMount() {


   }
   componentDidMount() {

      const location = this.props.location.pathname
      this.productLocationSetter(location)

      this.props.updateSlug(this.props.data.prismicStandardPage.uid);
      this.props.updateMeta(this.props.data.prismicStandardPage.data.meta_title.text, this.props.data.prismicStandardPage.data.meta_description);
      this.props.togglePopup(false);
      this.props.updatePageType(this.props.data.prismicStandardPage.type);
      this.props.updateProductHide(false);
      this.props.updateFooterVisible(true);
   }



   productLocationSetter = location => {
      switch (location) {
         case '/the-mills/the-mills-townhouses':
            this.setState({ location: 'the-mills-townhouses' })
            break
         case '/artisan/artisan-residences':
            this.setState({ location: 'artisan-residences' })
            break
         case '/artisan/artisan--culinary-house':
            this.setState({ location: 'culinary-house' })
            break
         case '/parkview/parkview-houses':
            this.setState({ location: 'parkview-houses' })
            break
         case '/parkview/parkview-apartments':
            this.setState({ location: 'parkview-apartments' })
            break
      }
   }

   render() {

      let data = this.props.data.prismicStandardPage.dataString
      data = JSON.parse(this.props.data.prismicStandardPage.dataString)
      data.theme = data.theme.toLowerCase()
      if (data.theme == 'grey') {
         data.theme = 'light'
      }

      let dynamicTheme = data.theme;
      if(data.theme === 'dark'){
         dynamicTheme = 'light';
      }

      if(data.theme === 'light'){
         dynamicTheme = 'dark';
      }

      var i = 0
      const location = this.state.location || ''
      return (
         <StandardWrapper>
            <Header togglePopup={this.props.togglePopup} theme={data.theme} custom={data.custom_colour} menu={this.props.data.prismicMainNavigation.data} />{' '}
            <StickyEnquire theme={dynamicTheme} togglePopup={this.props.togglePopup} togglePopupState={this.props.popupVisible} utm={this.props.utm} updateFormDetails={(first_name,last_name,phone,email) => this.props.updateFormDetails(first_name,last_name,phone,email)}/>

            {data.body.map(function (slice, index) {
               i++
               switch (slice.slice_type) {
                  case 'popup_map':
                     return (
                        <Masterplan key={index} />
                     )
                  case 'location_map':
                     return <LocationMap key={index} />
                  case 'accordian':
                     return (
                        <AccordionContainer key={index}>
                           <div className="grid">
                              <div className="inner" >
                                 {slice.items.map((i, idx) => {
                                    return (
                                       <Accordion
                                          title={i.title[0].text}
                                          bath={i.bathroom}
                                          bed={i.bedroom}
                                          car={i.carpark}
                                          study={i.study}
                                          name={i.title[0].text}
                                          logo={i.logo.url}
                                          image={i.image.url}
                                          dir="right"
                                          cta={{ link: i['link']['url'], text: 'Read more' }}
                                          html={RichText.render(i.html)}
                                       />
                                    )
                                 })}
                              </div>
                           </div>
                        </AccordionContainer>
                     )

                  case 'text_hero':
                     return (
                        <div
                           key={index}
                           className={`bg ${data.theme}`}
                           style={{ background: data.custom_colour }}>
                           <div className="grid">
                              <div className="inner">
                                 <Jumbotron
                                    title={slice.primary.title[0] ? slice.primary.title[0].text : ''}
                                    description={slice.primary.description[0] ? slice.primary.description[0].text : ''}
                                 />
                              </div>
                           </div>
                        </div>
                     )
                  case 'text_block':
                     return (
                        <TextBlock
                           key={index}
                           header={slice.primary.title}
                           subheader={slice.primary.sub_title}
                           text={slice.primary.text}
                           buttons={slice.items}
                        />
                     )
                  case 'photo':
                     if ( slice.items.length === 0 ) {
                        return '';
                     }

                     var fixText = false
                     var hero = false
                     if (!slice[1]) {
                        fixText = true
                     }
                     if (i === 1) {
                        hero = true
                     }

                     var regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/;
                     var youtube_match = slice.items[0].youtube__optional_.url ? slice.items[0].youtube__optional_.url.match(regExp) : false
                     
                     var class_str = Object.keys(slice.items[0].logo).length > 0 || slice.items[0].header.length > 0 || slice.items[0].subheader.length > 0 || slice.items[0].text.length > 0 || slice.items[0].link !== null ? 'bg mini' : '';

                     return (
                        <div
                           key={index}
                           className={hero ? `${class_str} ${data.theme}` : ``}
                           style={{ color: i === 1 && data.custom_colour }}>

                           {i === 1 && data.body[0].primary.hero_overlay.url
                              ? (
                                 <HeroOverlay
                                    src={data.body[0].primary.hero_overlay.url}
                                    alt="hero overlay"
                                 />
                              ) : (
                                 ''
                              )
                           }
                           {
                              i === 1 && data.body[0].items[0].youtube__optional_.url
                                 ? (
                                    <div>
                                       <BGDark className="bg mini dark">
                                          <div className="grid">
                                             <div className="inner">
                                                <div className="col col-xs-12 col-12 ">
                                                   <VideoOuterWrapper>
                                                      <VideoWrapper>
                                                      <iframe width="560" height="315" src={"https://www.youtube.com/embed/"+youtube_match[1]+"?rel=0&autohide=1&modestbranding=1&mute=1&autoplay=1&loop=1&playlist="+youtube_match[1]} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                                                      </VideoWrapper>
                                                   </VideoOuterWrapper>
                                                </div>
                                             </div>
                                          </div>
                                       </BGDark>

                                       {!!fixText &&
                                          <div className="grid" style={{marginBottom: '5rem'}}>
                                             <div className="inner" >
                                                <MainCopy className="col col-xs-12 col-06 ">
                                                         {slice.items[0].logo && (
                                                         <img src={slice.items[0].logo.url} />
                                                         ) }
                                                   {RichText.render(slice.items[0].header)}

                                                   {RichText.render(slice.items[0].subheader)}
                                                </MainCopy>
                                                <Text isHero={hero} className="col col-xs-12 col-04">
                                                   {RichText.render(slice.items[0].text)}

                                                   {/* if no link, no show. if external link, target blank. if linked to booking, show special format. else show Enquire Now */}
                                                   {!slice.items[0].link ? '' : slice.items[0].link.includes('http') ?
                                                      <a className="btn btn-arrow" href={`${slice.items[0].link}`} target="_blank" ><span>Read More</span> </a>
                                                      :
                                                      slice.items[0].link.includes('booking') ?
                                                      <Link className="btn btn-square" to={slice.items[0].link}>
                                                         <span>
                                                            Book an appointment
                                                            </span>
                                                      </Link>
                                                      : slice.items[0].link && <Link className="btn btn-square white" to={slice.items[0].link}>
                                                      <span>
                                                         Enquire Now
                                                         </span> </Link>
                                                   }
                                                </Text>
                                             </div>
                                          </div>
                                       }
                                    </div>
                                 )
                                 : (
                                    <Photo
                                       slides={slice.items}
                                       fixText={fixText}
                                       hero={hero}
                                       key={i}
                                       theme={data.theme}
                                    />
                                 )
                           }

                        </div>
                     )
                  case 'text':
                     return (
                        <div className="grid" key={index}>
                           <div className="inner" style={{ marginBottom: '-5rem' }}>{RichText.render(slice.primary.text)}</div></div>
                     )

                  case 'content_block___logos':
                     return (

                        <TextBlockLogos
                           key={index}
                           logos={slice.items}
                           header={slice.primary.title[0].text}
                           subheader={slice.primary.sub_heading[0].text}
                        />

                        // <div className="grid ">
                        //    <div className="inner">
                        //       <div className="col col-xs-12 col-06 ">
                        //          <div>
                        //             <h2>{slice.primary.title[0].text}</h2>
                        //          </div>
                        //          <div>
                        //             <p>{slice.primary.sub_heading[0].text}</p>
                        //          </div>
                        //       </div>
                        //       <div className="col col-xs-12 col-04">
                        //          <div className="logo-grid">
                        //          {
                        //             slice.items.map((i, idx) => (
                        //                <div className='logo-grid__item'>
                        //                   <div className='logo-grid__content'>
                        //                      {i.logo.url}
                        //                   </div>
                        //                </div>
                        //             ))
                        //          }
                        //          </div>
                        //       </div>
                        //    </div>
                        // </div>
                     )

                  case 'content_block':
                     var dir = null
                     if (!slice.items[1]) {
                        dir = i % 2 ? 'left' : 'right'
                     }

                     slice.items.forEach((item, index) => {
                        if ( item.media_type === 'Carousel' ) {
                           var carousel_images = [];

                           if ( Object.keys(item.image).length > 0 ) {
                              carousel_images.push({
                                 img: item.image,
                              });
                           }

                           if ( Object.keys(item.image_2).length > 0 ) {
                              carousel_images.push({
                                 img: item.image_2,
                              });
                           }

                           if ( Object.keys(item.image_3).length > 0 ) {
                              carousel_images.push({
                                 img: item.image_3,
                              });
                           }

                           if ( Object.keys(item.image_4).length > 0 ) {
                              carousel_images.push({
                                 img: item.image_4,
                              });
                           }

                           slice.items[index].carousel_images = carousel_images;
                        }
                     });
                     
                     return (
                        <NewsItems className={dir ? `grid ` : ' grid two-columns'} key={index}>
                           {slice.items.map((i, idx) => (
                              <div
                                 className={dir ? `` : 'col col-xs-12 col-06 padd-r'}
                                 key={idx}>
                                 <NewsCard
                                    key={idx}
                                    tile_id={i.tile_id && i.tile_id.length > 0 ? i.tile_id[0].text.replace(/[^A-Za-z0-9-_]/g, '').toLowerCase() : ''}
                                    imageUrl={i.image.url}
                                    titleLeft=""
                                    passProperty={i.title[0] ? i.title[0].text : ''}
                                    titleRight={i.title[0] ? i.title[0].text : ''}
                                    text={RichText.render(i.text)}
                                    sub={
                                       i['sub_heading'][0]
                                          ? i['sub_heading'][0]['text']
                                          : ' '
                                    }
                                    showSeparator
                                    actionUrl={i['link']}
                                    imageDirection={dir}
                                    layout={dir ? `horizontal` : 'vertical'}
                                    className={dir ? ` two-columns` : ' '}
                                    btn={i.btn}
                                    media_type={i.media_type || 'Image'}
                                    videoUrl={i.media_type === 'YouTube' && i.youtube_url.length > 0 ? i.youtube_url[0].text : false}
                                    carousel_images={i.media_type === 'Carousel' && i.carousel_images.length > 0 ? i.carousel_images : []}
                                 />
                              </div>
                           ))}
                        </NewsItems>
                     )
               }
            })}
         </StandardWrapper>
      )
   }
}

export default errorPage

const StandardWrapper = styled.div`

`

const NewsItems = styled.div`
   &.two-columns > .col:nth-child(2n + 1) {
      clear: left;
   }
   &.three-columns > .col:nth-child(3n + 1) {
      clear: left;
   }
`

const HeroOverlay = styled.img`
   position: absolute;
   height: 70vh;
   min-height: 35rem;
   transform: translateX(-50%);
   left: 50%;
   top: 0;
   object-fit: cover;
   z-index: 1;
`

const Field = styled.div`
   border-bottom: 1px solid ${colors.inactiveColor};
   width: calc(50% - 1rem);
   display: inline-block;
   margin-bottom: 0rem;
   @supports (display: flex) {
      display: block;
   }

   ${below.mobile`
		width: 100%;
		margin-left: auto;
		margin-right: auto;
    display:block;
    margin-bottom: 0;
	`};
`

const VideoOuterWrapper = styled.div`

   padding: 8rem 5rem 0;
   ${below.tablet`
   padding: 8rem 3rem;
   `}
   ${below.mobile`
   padding: 8rem 1rem 4rem;
   `};

`

const VideoWrapper = styled.div`

   position: relative;
   padding-bottom: 56.25%; /* 16:9 */
   height: 0;


   iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      padding-bottom: 0;
      min-height: 0;
   }
`

const BGDark = styled.div`
   &:after {
      display:none;
   }
   margin-bottom: 3.25rem;

`

const MainCopy = styled.div`
   padding-bottom: ${vars.padding.inner}rem;
   padding-right: ${vars.padding.inner}rem;
   border-right: ${props => props.isHero ? '1' : '1'}px solid ${vars.colors.body};
   padding-left: 5rem;
	img{
		width: 200px;
	}
   ${below.tablet`
      padding-bottom: 0;
      border-right: none;
      padding-left: 0;
   `};

`

const Text = styled.div`
   padding-left: ${vars.padding.inner}rem;

   ${below.tablet`
      border-left: none;
      padding-left: 0;
   `};

   h4 {
      padding-bottom: 3rem;
   }
   h5 {
      font-size: ${vars.padding.inner / 2}rem;
      padding-bottom: ${vars.padding.inner / 5}rem;

   }
`

export const pageQuery = graphql`
   query standardPage($id: String) {
      prismicStandardPage(id: { eq: $id }) {
         id
         uid
         type
         dataString
         data {
            meta_title {
               html
               text
            }
            meta_description
         }
      }
      prismicMainNavigation {
         id
         dataString
         data {
           display_name {
             html
             text
           }
           nav {
             slice_type
             primary {
               label {
                 text
               }
               link {
                 text
               }
             }
             items {
               sub_nav_link_label {
                 text
               }
               sub_nav_link {
                 text
               }
             }
           }
         }
       }
   }
`



// WEBPACK FOOTER //
// ./src/templates/standardPage.js